(() => {
  const GRAVITY = 1180;
  const DRAG = 0.997;

  function init(section) {
    const machine = section.querySelector('[data-capsule-machine]');
    if (!machine || machine.dataset.ready === 'true') return;
    machine.dataset.ready = 'true';

    const chamber = machine.querySelector('[data-capsule-chamber]');
    const elements = [...machine.querySelectorAll('[data-capsule]')];
    const mixButton = machine.querySelector('[data-capsule-mix]');
    const status = machine.querySelector('[data-capsule-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let width = 0;
    let height = 0;
    let frame = 0;
    let lastTime = performance.now();
    let quietFrames = 0;
    let mixCount = 0;

    const bodies = elements.map((element, index) => ({
      element,
      radius: 42,
      x: 0,
      y: 0,
      vx: 0,
      vy: 0,
      angle: index % 2 ? 8 : -7,
      angularVelocity: index % 2 ? 25 : -30,
      restitution: 0.46 + index * 0.035,
      active: false,
      entered: false,
      delay: Number(element.dataset.delay || 0),
      startX: Number(element.dataset.x || 0.5),
      size: Number(element.dataset.size || 0.13)
    }));

    function bounds() {
      width = chamber.clientWidth;
      height = chamber.clientHeight;
    }

    function render() {
      bodies.forEach((body) => {
        body.element.style.width = `${body.radius * 2}px`;
        body.element.style.height = `${body.radius * 2}px`;
        body.element.style.opacity = body.active ? '1' : '0';
        body.element.style.transform = `translate3d(${body.x - body.radius}px,${body.y - body.radius}px,0) rotate(${body.angle}deg)`;
      });
    }

    function staticLayout(offset = 0) {
      const positions = [[.22,.68],[.5,.7],[.78,.69],[.3,.9],[.58,.9],[.82,.89]];
      bodies.forEach((body, index) => {
        const position = positions[(index + offset) % positions.length];
        body.active = true;
        body.entered = true;
        body.x = width * position[0];
        body.y = Math.min(height * position[1], height - body.radius - 10);
        body.vx = 0; body.vy = 0;
      });
      render();
    }

    function reset() {
      bounds();
      bodies.forEach((body) => {
        body.radius = Math.max(34, Math.min(62, width * body.size));
        body.x = width * body.startX;
        body.y = -body.radius * 1.5;
        body.vx = (body.startX - .5) * -90;
        body.vy = 30;
        body.active = false;
        body.entered = false;
      });
      if (reducedMotion) staticLayout();
      else {
        const start = performance.now();
        bodies.forEach((body) => { body.startAt = start + body.delay; });
        startAnimation();
      }
    }

    function resolveBoundary(body) {
      const padding = Math.max(8, width * .018);
      const left = padding + body.radius;
      const right = width - padding - body.radius;
      const floor = height - padding - body.radius;
      if (body.x < left) { body.x = left; body.vx = Math.abs(body.vx) * body.restitution; }
      if (body.x > right) { body.x = right; body.vx = -Math.abs(body.vx) * body.restitution; }
      if (body.entered && body.y < padding + body.radius) { body.y = padding + body.radius; body.vy = Math.abs(body.vy) * body.restitution; }
      if (body.y > floor) {
        body.y = floor;
        body.vy = Math.abs(body.vy) < 34 ? 0 : -Math.abs(body.vy) * body.restitution;
        body.vx *= .985;
        body.angularVelocity *= .94;
      }
    }

    function resolvePair(first, second) {
      if (!first.active || !second.active) return;
      const dx = second.x - first.x;
      const dy = second.y - first.y;
      const minimum = first.radius + second.radius;
      const squared = dx * dx + dy * dy;
      if (squared >= minimum * minimum) return;
      const distance = Math.max(Math.sqrt(squared), .001);
      const nx = dx / distance;
      const ny = dy / distance;
      const overlap = minimum - distance;
      first.x -= nx * overlap * .5; first.y -= ny * overlap * .5;
      second.x += nx * overlap * .5; second.y += ny * overlap * .5;
      const velocity = (second.vx - first.vx) * nx + (second.vy - first.vy) * ny;
      if (velocity > 0) return;
      const impulse = -(1 + Math.min(first.restitution, second.restitution)) * velocity * .5;
      first.vx -= impulse * nx; first.vy -= impulse * ny;
      second.vx += impulse * nx; second.vy += impulse * ny;
    }

    function tick(time) {
      frame = 0;
      const dt = Math.min(Math.max((time - lastTime) / 1000, 0), .024);
      lastTime = time;
      let energy = 0;
      bodies.forEach((body) => {
        if (time >= body.startAt) body.active = true;
        if (!body.active) return;
        body.vy += GRAVITY * dt;
        body.vx *= DRAG; body.vy *= DRAG;
        body.x += body.vx * dt; body.y += body.vy * dt;
        body.angle += body.angularVelocity * dt;
        body.angularVelocity *= .995;
        if (body.y >= body.radius + 10) body.entered = true;
        resolveBoundary(body);
        energy += Math.abs(body.vx) + Math.abs(body.vy) + Math.abs(body.angularVelocity);
      });
      for (let i = 0; i < bodies.length; i += 1) for (let j = i + 1; j < bodies.length; j += 1) resolvePair(bodies[i], bodies[j]);
      render();
      quietFrames = bodies.every((body) => body.active) && energy < 65 ? quietFrames + 1 : 0;
      if (quietFrames < 80 && !document.hidden) frame = requestAnimationFrame(tick);
    }

    function startAnimation() {
      if (!frame && !reducedMotion) { lastTime = performance.now(); frame = requestAnimationFrame(tick); }
    }

    function mix() {
      mixCount += 1;
      mixButton.classList.add('is-mixing');
      window.setTimeout(() => mixButton.classList.remove('is-mixing'), 480);
      if (status) status.textContent = `${mixCount}回目：スクイーズがもう一度はずみました。`;
      if (reducedMotion) { staticLayout(mixCount); return; }
      bodies.forEach((body) => {
        body.active = true; body.entered = true; body.startAt = 0;
        body.vx = (Math.random() - .5) * 920;
        body.vy = -440 - Math.random() * 540;
        body.angularVelocity = (Math.random() - .5) * 230;
      });
      quietFrames = 0;
      startAnimation();
    }

    elements.forEach((element, index) => {
      const character = element.querySelector('.jp-character');
      const squeeze = () => character?.classList.add('is-squeezed');
      const release = () => character?.classList.remove('is-squeezed');
      element.addEventListener('pointerdown', squeeze);
      element.addEventListener('pointerup', release);
      element.addEventListener('pointercancel', release);
      element.addEventListener('pointerleave', release);
      element.addEventListener('click', () => {
        const body = bodies[index];
        if (!reducedMotion) { body.vy = -260; body.vx += (Math.random() - .5) * 260; body.angularVelocity += (Math.random() - .5) * 120; quietFrames = 0; startAnimation(); }
      });
    });
    mixButton?.addEventListener('click', mix);

    const observer = new ResizeObserver(() => {
      const oldWidth = width || chamber.clientWidth;
      const oldHeight = height || chamber.clientHeight;
      bounds();
      bodies.forEach((body) => {
        body.x = Math.max(body.radius, Math.min(width - body.radius, body.x * width / oldWidth));
        body.y = Math.min(height - body.radius, body.y * height / oldHeight);
      });
      render();
    });
    observer.observe(chamber);
    reset();
  }

  function initAll(root = document) {
    root.querySelectorAll?.('[data-jp-capsule-section]').forEach(init);
    if (root.matches?.('[data-jp-capsule-section]')) init(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
